export default __webpack_public_path__ + "qca-white.png";